import React, { useEffect, useRef } from 'react';
import { coupleData } from '../data/mockData';

const useScrollAnimation = () => {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = ref.current?.querySelectorAll('.animate-on-scroll');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return ref;
};

const CoupleSection = () => {
  const sectionRef = useScrollAnimation();

  return (
    <section id="couple" className="relative pt-[50px] md:pt-[90px] lg:pt-[110px] bg-white">
      <div className="relative" ref={sectionRef}>
        {/* Olive band */}
        <div className="hidden lg:block absolute left-0 right-0 top-1/2 -translate-y-1/2 h-[340px] md:h-[380px] bg-olive-dark" />
        {/* Decorative horizontal lines */}
        <div className="hidden lg:block absolute left-0 right-0 top-1/2 -translate-y-1/2 h-[420px] md:h-[460px] border-y-[1.3px] border-black pointer-events-none" />

        <div className="flex flex-col lg:flex-row lg:items-center">
          {/* Bride Side */}
          <div className="flex-1 bg-olive-dark lg:bg-transparent relative flex items-center justify-center py-12 sm:py-16 px-5 sm:px-6 lg:px-10">
            <div className="max-w-md text-center animate-on-scroll animate-fade-left">
              <img src={coupleData.bride.icon} alt="Bride icon" className="w-14 h-14 mx-auto mb-4 opacity-70" />
              <h3 className="font-heading text-3xl sm:text-4xl md:text-5xl text-white mb-4">
                {coupleData.bride.name}
              </h3>
              <p className="font-body text-white/80 leading-relaxed text-sm sm:text-[15px] whitespace-pre-line mb-4">
                {coupleData.bride.description}
              </p>
              <p className="font-script text-lg sm:text-xl text-white/60 italic">
                {coupleData.bride.attribution}
              </p>
            </div>
          </div>

          {/* Center Image */}
          <div className="relative flex-shrink-0 w-full lg:w-auto flex items-center justify-center -my-12 sm:-my-16 lg:my-0 py-6 lg:py-20 z-10">
            <div className="relative w-[220px] h-[290px] sm:w-[260px] sm:h-[340px] md:w-[320px] md:h-[420px] lg:w-[400px] lg:h-[540px] animate-on-scroll animate-scale-in">
              <div className="absolute -inset-6 sm:-inset-8 md:-inset-10 rounded-[250px] sm:rounded-[300px] md:rounded-[330px] lg:rounded-[350px] border-[1.3px] border-black bg-white" />
              <div className="absolute inset-0 rounded-[220px] sm:rounded-[270px] md:rounded-[300px] lg:rounded-[320px] overflow-hidden shadow-xl">
                <img
                  src={coupleData.bride.image}
                  alt="Couple"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Groom Side */}
          <div className="flex-1 bg-olive-dark lg:bg-transparent relative flex items-center justify-center py-12 sm:py-16 px-5 sm:px-6 lg:px-10">
            <div className="max-w-md text-center animate-on-scroll animate-fade-right">
              <img src={coupleData.groom.icon} alt="Groom icon" className="w-14 h-14 mx-auto mb-4 opacity-70" />
              <h3 className="font-heading text-3xl sm:text-4xl md:text-5xl text-white mb-4">
                {coupleData.groom.name}
              </h3>
              <p className="font-body text-white/80 leading-relaxed text-sm sm:text-[15px] whitespace-pre-line mb-4">
                {coupleData.groom.description}
              </p>
              <p className="font-script text-lg sm:text-xl text-white/60 italic">
                {coupleData.groom.attribution}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoupleSection;
